// @flow
import React from 'react';
import styled from 'styled-components';
import { ApolloProvider } from '@apollo/client';

import { Fill } from 'layout-core-components';
import apolloClient from './apolloClient';
import ClientWebAppErrorBoundary from './ClientWebAppErrorBoundary';

const GlobalStyleWrapper = styled.div`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

type ClientWebAppProps = {
  children: Node,
  showEmptyFallbackUI: boolean,
  clientId: string,
};

const ClientWebApp = ({ clientId, children, showEmptyFallbackUI }: ClientWebAppProps) => (
  <ClientWebAppErrorBoundary clientId={clientId} showEmptyFallbackUI={showEmptyFallbackUI}>
    <ApolloProvider client={apolloClient}>
      <Fill to="parent">
        <GlobalStyleWrapper>{children}</GlobalStyleWrapper>
      </Fill>
    </ApolloProvider>
  </ClientWebAppErrorBoundary>
);

ClientWebApp.defaultProps = {
  showEmptyFallbackUI: false,
};

export default ClientWebApp;
